import React from 'react';
import { Link } from 'react-router-dom';
import Breadcrumbs from '../ui/Breadcrumbs';
import { motion } from 'framer-motion';
interface PageHeaderProps {
  title: string;
  description?: string;
  backgroundImage?: string;
  breadcrumbs?: Array<{
    label: string;
    path: string;
  }>;
  buttons?: React.ReactNode;
  centered?: boolean;
  size?: 'sm' | 'md' | 'lg';
  overlay?: 'none' | 'light' | 'medium' | 'dark';
}
const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  description,
  backgroundImage,
  breadcrumbs,
  buttons,
  centered = true,
  size = 'md',
  overlay = 'medium'
}) => {
  const sizeClasses = {
    sm: 'py-8 md:py-12',
    md: 'py-12 md:py-16',
    lg: 'py-16 md:py-24'
  };
  const overlayClasses = {
    none: '',
    light: 'bg-blue-900/60',
    medium: 'bg-blue-900/75',
    dark: 'bg-blue-900/90'
  };
  const defaultImage = 'https://uploadthingy.s3.us-west-1.amazonaws.com/jdfoyTCXLviMyjmi5MDX1X/WhatsApp_Image_2025-10-24_at_11.30.13.jpg';
  return <div className="relative text-white overflow-hidden" data-id="element-506">
      {/* Background image */}
      <motion.div className="absolute inset-0 z-0" initial={{
      scale: 1.1
    }} animate={{
      scale: 1
    }} transition={{
      duration: 1.2,
      ease: 'easeOut'
    }} data-id="element-507">
        <div className={`absolute inset-0 z-10 ${overlayClasses[overlay]}`} data-id="element-508"></div>
        <img src={backgroundImage || defaultImage} alt={title} className="w-full h-full object-cover" data-id="element-509" />
      </motion.div>
      {/* Content */}
      <div className={`container mx-auto px-4 relative z-10 ${sizeClasses[size]}`} data-id="element-510">
        {breadcrumbs && <motion.div className="mb-6" initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-511">
            <Breadcrumbs items={breadcrumbs} className="text-white/80" data-id="element-512" />
          </motion.div>}
        <div className={`max-w-4xl ${centered ? 'mx-auto text-center' : ''}`} data-id="element-513">
          <motion.h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} data-id="element-514">
            {title}
          </motion.h1>
          {description && <motion.p className="text-lg md:text-xl text-white/90 max-w-3xl mb-6 mx-auto" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} data-id="element-515">
              {description}
            </motion.p>}
          {buttons && <motion.div className="mt-8 flex flex-wrap gap-4 justify-center" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.6
        }} data-id="element-516">
              {buttons}
            </motion.div>}
        </div>
      </div>
      {/* Bottom gradient */}
      <div className="absolute bottom-0 left-0 right-0 h-12 bg-gradient-to-t from-blue-950 to-transparent z-10" data-id="element-517"></div>
    </div>;
};
export default PageHeader;